import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function StudentTable() {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterClass, setFilterClass] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [classes, setClasses] = useState([]);
  const navigate = useNavigate();
const [filterSection, setFilterSection] = useState('');


 useEffect(() => {
  const currentSessionId = localStorage.getItem("currentSessionId");

  async function fetchData() {
    try {
      const [studentsResponse, classesResponse] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`, {
          params: { sessionId: currentSessionId },
        }),
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`, {
          params: { sessionId: currentSessionId },
        }),
      ]);

      setStudents(studentsResponse.data);
      setFilteredStudents(studentsResponse.data);
      setClasses(classesResponse.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  fetchData();
}, []);


  const handleViewClick = (id) => navigate(`/students/${id}`);

  const handleDeactivate = (id) => navigate(`/Deactivate/${id}`);

  const handleSearch = () => {
  let tempStudents = students;

  if (searchTerm) {
    tempStudents = tempStudents.filter((student) =>
      student.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      student.rollNo?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  if (filterClass) {
    tempStudents = tempStudents.filter(
      (student) => student.class === filterClass
    );
  }

  if (filterSection) {
    tempStudents = tempStudents.filter(
      (student) => student.section === filterSection
    );
  }

if (filterStatus) {
  tempStudents = tempStudents.filter(
    (student) =>
      student.status?.toLowerCase() === filterStatus.toLowerCase()
  );
}

  setFilteredStudents(tempStudents);
};
const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to permanently delete this student?")) return;

  try {
    await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/students/deleteStudent/${id}`);

    // remove from UI instantly
    setStudents(prev => prev.filter(student => student._id !== id));
    setFilteredStudents(prev => prev.filter(student => student._id !== id));

    alert("Student deleted successfully");
  } catch (error) {
    console.error(error);
    alert("Error deleting student");
  }
};


  const labelStyle = "text-black font-semibold text-[18px]";
  const inputStyle =
    "p-2 border border-gray-300 rounded w-full placeholder:text-gray-400 placeholder:text-[14px]";

  return (
    <div className="min-h-screen p-4 sm:p-6 bg-white">
      <div className="max-w-7xl mx-auto">

        {/* TITLE (unchanged) */}
      

        {/* Filters */}
        <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">

          <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-2 sm:space-y-0">

            {/* Search */}
            <input
              type="text"
              placeholder="Search by Name or Roll Number"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={`${inputStyle} sm:w-72`}
            />

            {/* Class Filter */}
            <select
              value={filterClass}
              onChange={(e) => setFilterClass(e.target.value)}
              className={`${inputStyle} sm:w-48`}
            >
              <option value="">Filter by Class</option>
              {classes.map((cls, index) => (
                <option key={index} value={cls.className}>
                  {cls.className}
                </option>
              ))}
            </select>

            {/* Status Filter */}
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className={`${inputStyle} sm:w-40`}
            >
              <option value="">Filter by Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>

            {/* Search Button */}
            <button
              onClick={handleSearch}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center justify-center"
            >
              <i className="fas fa-search mr-2"></i>Search
            </button>

          </div>

          {/* Total Students */}
          <div className="flex items-center bg-blue-100 text-blue-700 rounded px-4 py-2 justify-center sm:justify-start">
            <i className="fas fa-users text-2xl mr-2"></i>
            <p className={`${labelStyle}`}>Total Students: {filteredStudents.length}</p>
          </div>

        </div>

        {/* TABLE (Desktop) */}
        <div className="hidden md:block overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg">
            <thead className="bg-gray-200">
              <tr>
                <th className="py-2 px-4 border-b border-gray-300 text-left text-[18px] font-semibold text-black">
                  Student Name
                </th>
                <th className="py-2 px-4 border-b border-gray-300 text-left text-[18px] font-semibold text-black">
                  Father's Name
                </th>
                <th className="py-2 px-4 border-b border-gray-300 text-left text-[18px] font-semibold text-black">
                  Roll Number
                </th>
                <th className="py-2 px-4 border-b border-gray-300 text-left text-[18px] font-semibold text-black">
  Class
</th>

                <th className="py-2 px-4 border-b border-gray-300 text-left text-[18px] font-semibold text-black">
                  Status
                </th>
                <th className="py-2 px-4 border-b border-gray-300 text-left text-[18px] font-semibold text-black">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredStudents.map((student) => (
                <tr key={student._id} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border-b border-gray-300">
                    {student.firstName} {student.lastName}
                  </td>
                  <td className="py-2 px-4 border-b border-gray-300">{student.fatherName}</td>
                  <td className="py-2 px-4 border-b border-gray-300">{student.rollNo}</td>
                  <td className="py-2 px-4 border-b border-gray-300">
  {student.class} ({student.section})
</td>

                  <td className="py-2 px-4 border-b border-gray-300 capitalize">
                    {student.status}
                  </td>

                  {/* ACTION BUTTONS */}
                  <td className="py-2 px-4 border-b border-gray-300">
                    <div className="flex flex-wrap gap-2">
  <button
    onClick={() => handleViewClick(student._id)}
    className="px-2 py-1 bg-green-600 text-white rounded hover:bg-green-500 flex items-center"
  >
    <i className="fas fa-eye mr-1"></i>View
  </button>

  {/* Activate / Deactivate */}
  <button
    onClick={() => handleDeactivate(student._id)}
    className={`px-2 py-1 ${
      student.status === 'active'
        ? 'bg-red-600 hover:bg-red-500'
        : 'bg-green-600 hover:bg-green-500'
    } text-white rounded flex items-center`}
  >
    <i
      className={`fa-solid fa-${
        student.status === 'active' ? 'ban' : 'check'
      } mr-1`}
    ></i>
    {student.status === 'active' ? 'Deactivate' : 'Activate'}
  </button>

 <button
  onClick={() => handleDelete(student._id)}
  className="px-2 py-1 bg-black text-white rounded hover:bg-gray-800 flex items-center"
>
  <i className="fas fa-trash mr-1"></i>Delete
</button>

</div>

                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* CARD VIEW (Mobile) */}
        <div className="md:hidden flex flex-col gap-4">
          {filteredStudents.map((student) => (
            <div key={student._id} className="bg-white p-4 rounded-lg shadow-md">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h2 className="font-semibold text-[18px] text-black">
                    {student.firstName} {student.lastName}
                  </h2>

                  <p className="text-gray-700 text-[14px]">
                    <span className="font-semibold text-black">Father:</span> {student.fatherName}
                  </p>

                  <p className="text-gray-700 text-[14px]">
                    <span className="font-semibold text-black">Roll No:</span> {student.rollNo}
                  </p>
<p className="text-gray-700 text-[14px]">
  <span className="font-semibold text-black">Class:</span>{" "}
  {student.class} ({student.section})
</p>

                  <p className="text-gray-700 text-[14px] capitalize">
                    <span className="font-semibold text-black">Status:</span> {student.status}
                  </p>
                </div>

                <div className="flex flex-col gap-2">
                  <button
                    onClick={() => handleViewClick(student._id)}
                    className="px-2 py-1 bg-green-600 text-white rounded hover:bg-green-500 flex items-center justify-center"
                  >
                    <i className="fas fa-eye mr-1"></i>View
                  </button>

                  <button
                    onClick={() => handleDeactivate(student._id)}
                    className={`px-2 py-1 ${
                      student.status === 'active'
                        ? 'bg-red-600 hover:bg-red-500'
                        : 'bg-green-600 hover:bg-green-500'
                    } text-white rounded flex items-center justify-center`}
                  >
                    <i
                      className={`fa-solid fa-${student.status === 'active' ? 'ban' : 'check'} mr-1`}
                    ></i>
                    {student.status === 'active' ? 'Deactivate' : 'Activate'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default StudentTable;
